import { ECareerLandingPageTabs, thunkActionLoading } from '@configs'
import { zodResolver } from '@hookform/resolvers/zod'
import { useAppDispatch, useAppSelector } from '@redux'
import { Skeleton, message } from 'antd'
import { Fragment, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'src/common'
import { EMediaCategory } from 'src/interfaces/gallery'
import MetaTab from 'src/pages/blog/content/MetaTab'
import {
  getCareerPageSeoAction,
  updateCareerPageSeoAction,
} from 'src/redux/actions/career-landing-management'
import { ISeoPageSchema, seoConfigSchema } from './seoConfigSchema'

interface IAboutUsPageSeoProps {
  activeTab: string
}

const CareerPageSeo = ({ activeTab }: IAboutUsPageSeoProps) => {
  const dispatch = useAppDispatch()

  const seoConfig = useAppSelector((state) => state.careerLanding.careerSeo)
  const isGetSeoActionLoading = useAppSelector(
    (state) =>
      state.careerLanding?.loadings[
        thunkActionLoading.GET_CAREER_SEO_CONFIG_LOADING
      ]
  )

  const isUpdating = useAppSelector(
    (state) =>
      state.careerLanding?.loadings[
        thunkActionLoading.UPDATE_CAREER_SEO_CONFIG_LOADING
      ]
  )

  const { handleSubmit, control, setValue, getValues } =
    useForm<ISeoPageSchema>({
      defaultValues: {
        metaTitle: '',
        metaDescription: '',
        metaImage: '',
        canonical: '',
        schemaMarkup: 'schema mark up',
        keywords: '',
      },
      resolver: zodResolver(seoConfigSchema),
      mode: 'onSubmit',
      reValidateMode: 'onChange',
    })

  const onSubmit = async (data: ISeoPageSchema) => {
    try {
      const response = await dispatch(updateCareerPageSeoAction(data)).unwrap()
      if (response.success) {
        message.success(response?.message ?? '')
      }
    } catch (error: any) {
      message.error(error?.message ?? '')
    }
  }

  const handleClickSave = () => {
    handleSubmit(onSubmit)()
  }

  useEffect(() => {
    if (activeTab === ECareerLandingPageTabs.SEO_CONFIG) {
      const getCareerPageSeo = async () => {
        try {
          await dispatch(getCareerPageSeoAction()).unwrap()
        } catch (error: any) {
          message.error(error?.message ?? '')
        }
      }
      getCareerPageSeo()
    }
  }, [activeTab])

  useEffect(() => {
    if (seoConfig) {
      setValue('metaTitle', seoConfig?.metaData?.metaTitle || '')
      setValue('metaDescription', seoConfig?.metaData?.metaDescription || '')
      setValue('metaImage', seoConfig?.metaData?.metaImage || '')
      setValue('canonical', seoConfig?.metaData?.canonical || '')
      setValue('keywords', seoConfig?.metaData?.keywords || '')
    }
  }, [seoConfig])

  return (
    <Fragment>
      {isGetSeoActionLoading ? (
        <>
          <Skeleton
            paragraph={{ rows: 4 }}
            style={{
              marginTop: 10,
            }}
          />
        </>
      ) : (
        <div className="bg-white">
          <MetaTab
            activeTab={activeTab}
            control={control}
            getValues={getValues}
            setValue={setValue}
            isShowSelectMedia
            category={EMediaCategory.CONTENT}
          />

          <div className="term-policy-action mr-5 pb-5 flex items-center justify-end gap-6">
            <Button
              type="primary"
              size="small"
              id="blog-form"
              onClick={() => {
                handleClickSave()
              }}
              loading={isUpdating || isGetSeoActionLoading}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </Fragment>
  )
}

export default CareerPageSeo
